import "./clients.css";
import Cl1 from "assets/png/cl1.png";
import Cl2 from "assets/png/cl2.png";
import Cl3 from "assets/png/cl3.png";
import Cl4 from "assets/png/cl4.png";
import Cl5 from "assets/png/cl5.png";
import Cl6 from "assets/png/cl6.png";
import Cl7 from "assets/png/cl7.png";
import Cl8 from "assets/png/cl8.jpeg";
import Cl9 from "assets/png/cl9.jpeg";
import Cl10 from "assets/png/cl10.jpeg";
import Cl11 from "assets/png/cl11.jpeg";
import Cl12 from "assets/png/cl12.png";
import Cl13 from "assets/png/cl13.jpeg";
import Cl14 from "assets/png/cl14.jpeg";
import Cl15 from "assets/png/cl15.jpeg";
import Cl16 from "assets/png/cl16.jpeg";
import Cl17 from "assets/png/cl17.jpeg";
import Cl18 from "assets/png/cl18.jpeg";
import Cl19 from "assets/png/cl19.png";
import Cl20 from "assets/png/cl20.jpeg";
// import Cl21 from "assets/png/cl21.jpeg";
// import Cl22 from "assets/png/cl22.jpeg";
import Cl23 from "assets/png/cl23.jpeg";
import Cl24 from "assets/png/cl24.png";
import Cl25 from "assets/png/cl25.png";

const Clients = () => {
  return (
    <div className="clients" id="partners">
      <div className="three-block">
        <p className="subtitle gray pry-text text-center mb-2">OUR CLIENTS</p>
        <p className="header purple pry-text center">
          <span className="gray">Meet the Guardians of Trust:</span>
          <br /> Our Valued Clients
        </p>
      </div>

      <div className="client-grid">
        <img src={Cl1} alt="" />
        <img src={Cl2} alt="" />
        <img src={Cl3} alt="" />
        <img src={Cl4} alt="" />
        <img src={Cl5} alt="" />
        <img src={Cl6} alt="" />
        <img src={Cl7} alt="" />
        <img src={Cl8} alt="" />
        <img src={Cl9} alt="" />
        <img src={Cl10} alt="" />
        <img src={Cl11} alt="" />
        <img src={Cl12} alt="" />
        <img src={Cl13} alt="" />
        <img src={Cl14} alt="" />
        <img src={Cl15} alt="" />
        <img src={Cl16} alt="" />
        <img src={Cl17} alt="" />
        <img src={Cl18} alt="" />
        <img src={Cl19} alt="" />
        <img src={Cl20} alt="" />
        {/* <img src={Cl21} alt="" /> */}
        {/* <img src={Cl22} alt="" /> */}
        <img src={Cl23} alt="" />
        <img src={Cl24} alt="" />
        <img src={Cl25} alt="" />
      </div>
    </div>
  );
};

export default Clients;
